/* eslint-disable react/jsx-filename-extension */
// import { ApolloProvider } from '@apollo/client';
// import React from 'react';
import createApolloClient from './apollo-client';

export function initializeApollo(initialState = null, userToken = null, hostname) {
  const apolloClient = createApolloClient(userToken, hostname);

  if (initialState) {
    apolloClient.cache.restore(initialState);
  }

  return apolloClient;
}

export function withApollo(PageComponent) {
  // function WithApollo(props) {
  //   // eslint-disable-next-line react/prop-types
  //   const { apolloState, userToken, ...pageProps } = props;
  //   const apolloClient = initializeApollo(apolloState, userToken);

  //   return (
  //     <ApolloProvider client={apolloClient}>
  //       {/* eslint-disable-next-line react/jsx-props-no-spreading */}
  //       <PageComponent {...pageProps} />
  //     </ApolloProvider>
  //   );
  // }
  // if (PageComponent.getInitialProps) {
  //   WithApollo.getInitialProps = PageComponent.getInitialProps;
  // }

  // return WithApollo;
  return null;
}
